// extracted by mini-css-extract-plugin
module.exports = {"centerLabel":"styles_centerLabel__2cIU8"};